import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';

import Points from './points';
import Playable from './playable';
import Playsmart from './playsmart';

import { getPlayable } from '@/api/dashboard/overview';
export default {
  components: {
    Points: Points, Playable: Playable, Playsmart: Playsmart
  },
  data: function data() {
    return {
      playableDatas: []
    };
  },
  mounted: function mounted() {},

  methods: {
    getPlayableData: function getPlayableData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, items;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getPlayable();

              case 2:
                res = _context.sent;
                items = _.get(res, 'data.data.items');

                _this.playableDatas = items;
                console.log(items);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};